export default "__VITE_ASSET__1e4226c1__"